import { Box, Typography } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import React from "react";

export default function TomanVal({ data }) {
  return (
    <Box display="flex" justifyContent="center">
      <Typography
        variant="h6"
        color="text.main"
        fontWeight={600}
        paddingRight={0.5}
      >
        <NumberFormats value={data.priceToToman} />
      </Typography>
      <Typography variant="h6" color="text.main" fontWeight={400}>
        Toman
      </Typography>
    </Box>
  );
}
